import clsx from 'clsx';
import React, { useRef, useState, useEffect } from 'react';
import classes from './Tooltip.module.scss';

interface TooltipProps {
  tip: React.ReactNode;
  tipClassName?: string;
  children: React.ReactNode;
  wrapperClassName?: string;
}

const Tooltip: React.FC<TooltipProps> = ({ children, wrapperClassName, tipClassName, tip }) => {
  const rootRef = useRef<HTMLDivElement>(null);
  const tipRef = useRef<HTMLDivElement>(null);
  const [layoutFix, setLayoutFix] = useState<string | null>(null);

  useEffect(() => {
    if (rootRef.current && tipRef.current) {
      const rootBox = rootRef.current.getBoundingClientRect();
      const tipBox = tipRef.current.getBoundingClientRect();

      if (rootBox.left + rootBox.width / 2 + tipBox.width / 2 > window.innerWidth) {
        setLayoutFix('right');
      } else if (rootBox.left - rootBox.width / 2 + tipBox.width / 2 < 0) {
        setLayoutFix('left');
      } else {
        setLayoutFix(null);
      }
    }
  }, []);

  return (
    <div className={clsx(wrapperClassName, classes.root)} ref={rootRef}>
      {children}
      <div
        className={classes.arrow}
        style={
          layoutFix === 'right'
            ? { right: '8px', left: 'auto', marginLeft: 0 }
            : layoutFix === 'left'
              ? { left: '8px', marginLeft: 0 }
              : undefined
        }
      />
      <div
        className={classes.tip}
        ref={tipRef}
        style={
          layoutFix === 'right'
            ? { right: 0, left: 'auto', transform: 'none' }
            : layoutFix === 'left'
              ? { left: 0, transform: 'none' }
              : undefined
        }
      >
        {tipClassName ? <div className={tipClassName}>{tip}</div> : tip}
      </div>
    </div>
  );
};

export default Tooltip;
